"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTooltipErrorText = void 0;
var tooltipSizeErrorDefaultText = 'The file size exceeds the allowed limit';
var tooltipAspectRatioErrorDefaultText = 'The aspect ratio of this image is not within the allowed range';
var tooltipFetchErrorDefaultText = 'The image cannot be loaded';
var tooltipImageEditionSuggestionText = 'Crop the image to publish it';
var getTooltipErrorText = exports.getTooltipErrorText = function getTooltipErrorText(item, texts, editable) {
  if (item.fetchError) {
    var _texts$fetchError;
    return (_texts$fetchError = texts.fetchError) !== null && _texts$fetchError !== void 0 ? _texts$fetchError : tooltipFetchErrorDefaultText;
  }
  if (item.sizeError && !editable) {
    var _texts$sizeError;
    return (_texts$sizeError = texts.sizeError) !== null && _texts$sizeError !== void 0 ? _texts$sizeError : tooltipSizeErrorDefaultText;
  }
  if (item.aspectRatioError && !editable) {
    var _texts$aspectRatioErr;
    return (_texts$aspectRatioErr = texts.aspectRatioError) !== null && _texts$aspectRatioErr !== void 0 ? _texts$aspectRatioErr : tooltipAspectRatioErrorDefaultText;
  }
  if ((item.aspectRatioError || item.sizeError) && editable) {
    var _texts$cropImageSugge;
    return (_texts$cropImageSugge = texts.cropImageSuggestion) !== null && _texts$cropImageSugge !== void 0 ? _texts$cropImageSugge : tooltipImageEditionSuggestionText;
  }
  return null;
};